import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import TkButton from "../../components/atoms/TkButton";
import TkDataTable from "../../components/molecules/TkDataTable";
import { headTitleList } from "./parts";
import { httpAPI_AGE001, httpAPI_AGE004 } from "./api/request";
import { handleList } from "./hooks/useHooks";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkDialog from "../../components/atoms/TkDialog";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { contextText } from "./parts";

/**
 * SCRC100002 代行者の管理
 * @returns JSX.Element
 */
const SCRC100002 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [bodyListData, setbodyListData] = useState();
  const ref = useRef();
  const [open, setOpen] = useState(false);

  // 初期化
  const handleInit = async () => {
    try {
      const res = await httpAPI_AGE001({
        contractorNo: state.authInfo?.contractorNo + "",
      });

      if (res.resultCd === "I0000") {
        setbodyListData(handleList(res.agentList, handleDelete, handleFix));
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 削除ボタン
  const handleDelete = (item: any) => {
    ref.current = item.userId;
    setOpen(true);
  };

  const onDelete = async () => {
    setOpen(false);
    const userId = ref.current;
    try {
      const res = await httpAPI_AGE004({
        userId: userId,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        handleInit();
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 修正ボタン
  const handleFix = (item: any) => {
    navigate("/SCRC100003", { state: { userId: item?.userId } });
  };

  // 代行者の新規登録
  const handleNew = () => {
    navigate("/SCRC100003", { state: { userId: "" } });
  };

  return (
    <Box className="SCRC100002" data-testid="SCRC100002PageForTest">
      <Box className="info">
        <Typography>登録されている代行者の一覧</Typography>
        <TkButton onClick={handleNew}>代行者の新規登録</TkButton>
      </Box>
      <TkDataTable headList={headTitleList} bodyList={bodyListData || []} />
      <Box className="backBtn">
        <TkBackButton />
      </Box>

      <TkDialog
        title="確認（代行者を削除します）"
        children={<TkInfoManual rule={"<"}>{contextText}</TkInfoManual>}
        open={open}
        okText="はい"
        cancelText="いいえ"
        onCancel={() => setOpen(false)}
        onSave={() => onDelete()}
      />
    </Box>
  );
};

export default SCRC100002;
